import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';

import NotesList  from 'src/component/UI/NotesList';
import FilterBar from 'src/component/UI/FilterBar';

import { fetchNotes } from 'src/module/note/action';
import { getFacilityNotes, getLoadingFacilityNotes, getNumFacilityNotesPages, getTotalFacilityNotes } from 'src/module/note/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function CrossShiftsScreen () {
  const { t } = useTranslation();
  const selectors = {
    getNotes: getFacilityNotes,
    getLoadingNotes: getLoadingFacilityNotes,
    getNumNotesPages: getNumFacilityNotesPages,
    getTotalNotes: getTotalFacilityNotes
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='facility-screen'>
      <Helmet>
        <title>{title} - {t('notes.facility')}</title>
      </Helmet>
      <FilterBar includeGrid />
      <br />
      <Paper>
        <NotesList
          noteType={'facility'}
          selectors={selectors}
          hideDeviceTag
          showCreatedBy
          showCreatedAt
          hideDeviceSelector
          showSubject
          showAddNoteButton
          showSearchBar
          showArchivedOption
          showDeleteIcon
          fetch={fetchNotes}
        />
      </Paper>
    </div>
  );
}
